<template>
  <div :class="classes">
    <div class="wf-flex wf-justify-between wf-items-center">
      <img class="wf-w-48" src="https://storage.googleapis.com/wfs/images/logo-01.png" alt="">
      <nav>
        <ul class="wf-flex wf-items-baseline" :class="containerNavLinkClasses">
          <template v-for="(navLink, index) in navLinks">
            <HeaderNavLink
              :key="index"
              :navLink="navLink"
              :classes="navLinkClasses"
              :styles="navLinkStyles"
              :subMenuContainerClasses="subMenuContainerClasses"
              :subMenuContainerStyles="subMenuContainerStyles"
              :subMenuClasses="subMenuClasses"
              :subMenuStyles="subMenuStyles"
              :megaMenuClasses="megaMenuClasses"
              :megaMenuStyles="megaMenuStyles"
              :megaMenuFullWidth="megaMenuFullWidth"
              :megaMenuContainerClasses="megaMenuContainerClasses"
              :megaMenuContainerStyles="megaMenuContainerStyles"
              :megaMenuTitleClasses="megaMenuTitleClasses"
              :megaMenuTitleStyles="megaMenuTitleStyles"
            />
          </template>
          <li :class="ctaClasses" :style="ctaStyles" v-show="hasCta">
            <div v-text="ctaText"></div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
  import HeaderContract from '../../contracts/HeaderContract'
  export default HeaderContract.extend({})
</script>